import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import http from '@/utils/http'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    user: { email: '', token: '' },
    loginError: ''
  },
  mutations: {
    userLoggedIn(state, user) {
      try {
        localStorage.setItem('gigportaltoken', user.token)
      } catch (e) {
        // tslint:disable:no-console
        console.error('warning: could not save token to localstorage:', e)
      }
      state.user = user
      state.loginError = ''
      router.push({name: 'home'})
      http.setUser(user)
    },
    userLoggedOut(state) {
      try {
        localStorage.setItem('gigportaltoken', '')
      } catch (e) {
        // tslint:disable:no-console
        console.error('warning: could not clear token in localstorage:', e)
      }
      state.user = { email: '', token: '' }
      state.loginError = ''
      router.push({name: 'login'})
      http.setUser({})
    },
    resetLoginError(state) {
      state.loginError = ''
    }
  },
  actions: {
    logout(state: any) {
      this.commit('userLoggedOut')
      if (state && state.user && state.user.token) {
        http.post('/auth/logout', { token: state.user.token })
      }
    },
    login(state: any, params: any) {
      this.commit('resetLoginError')
      const request = {
        email: params.email,
        password: params.password
      }
      http.post('/auth/login', request)
        .then((response: any) => {
          const user = { email: params.email, token: response.data.token }
          this.commit('userLoggedIn', user)
        })
        .catch((err: any) => {
          this.state.loginError = err.response && err.response.data && err.response.data.errorMessage
            ? err.response.data.errorMessage
            : 'Error communicating with backend (' + err + ')'
        })

    }
  }
})
